import { useParams } from "react-router-dom";
import {
  Headline5,
  RegularText,
  MediumText,
  SmallText,
} from "~/shared/components/typography";
import { Link } from "react-router-dom";
import ScrollToTop from "~/shared/components/ScrollToTop";

import {
  FlexColumn,
  FlexRowSpaceBetween,
  flex,
} from "~/shared/components/flexes";
import styled from "styled-components";
import { ReactComponent as ZigzagLine } from "~/shared/assets/zigzagLine.svg";
import type { PostShape } from "./types";

const Wrapper = styled(FlexColumn)`
  gap: 15px;
`;

const TitleWrapper = styled(FlexColumn)``;

const Title = styled(Headline5)`
  color: var(--primary-4);
`;

const PostContent = styled(MediumText)``;

const BackLick = styled(Link)`
  ${flex};
  text-decoration: underline !important;
`;

const AuthorNameLine = styled(FlexColumn)`
  gap: 15px;
`;

const Name = styled(SmallText)``;

function Post({ posts }: { posts?: PostShape[] }) {
  const { id } = useParams<{ id: string }>();

  const post = posts?.find((post) => post.id === id);

  if (!post) return null;

  return (
    <Wrapper>
      <ScrollToTop />

      <TitleWrapper>
        <FlexRowSpaceBetween>
          <Title>{post.title}</Title>

          <BackLick to="/">חזרה</BackLick>
        </FlexRowSpaceBetween>

        <AuthorNameLine>
          <Name weight="medium">
            {post?.authorName}, {post?.role}
          </Name>

          <ZigzagLine />
        </AuthorNameLine>
      </TitleWrapper>

      <PostContent
        dangerouslySetInnerHTML={{
          __html: post.content.html.replace(/\u00a0/g, " "),
        }}
      />
    </Wrapper>
  );
}

export default Post;
